<div class="d-flex" [matTooltip]="getTooltipLabel()" matTooltipPosition="below">
  <svg class="compatibility-icon">
    <circle cx="8" cy="8" r="8" [attr.fill]="fillColor" />
  </svg>
  <span>
    {{ interfaceConfiguration.interface.name }}
  </span>
</div>
